module.exports = "<div [ngClass]=\"{'flip-container': true, 'active': setActiveClass, 'back-visible': setVisibleBack }\">\n  <div class=\"flipper\">\n    <div class=\"front\">\n      <img *ngIf=\"image\" src=\"{{image}}\" (load)=\"assetLoaded()\">\n      <div *ngIf=\"video\" class=\"video\">\n      <video autoplay loop muted>\n        <source src=\"{{video}}\" type=\"video/mp4\">\n      </video>\n      </div>\n    </div>\n    <div class=\"back\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ipsc/gallery.component.html
// module id = ./src/app/ipsc/gallery.component.html
// module chunks = main